import { render, staticRenderFns } from "./ShokurekishoImageUploadFields.vue?vue&type=template&id=4f6cef38&scoped=true"
import script from "./ShokurekishoImageUploadFields.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShokurekishoImageUploadFields.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ShokurekishoImageUploadFields.vue?vue&type=style&index=0&id=4f6cef38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6cef38",
  null
  
)

export default component.exports